export function isAlphaNumeric(charCode) {
    // ASCII 48 - 57 : 0 - 9
    // ASCII 65 - 90 : A - Z
    // ASCII 97 - 122 : a - z
    return (
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122)
    );
}

export function validateMaxConsecutiveCharacters(str, maxConsecutive) {
    if (maxConsecutive <= 0) {
        // Return false if any characters are alphanumeric.
        return !Array.from(str)
            .map((char) => char.charCodeAt(0))
            .some(isAlphaNumeric);
    }

    const Direction = {
        None: 'None',
        Forward: 'Forward',
        Backward: 'Backward',
    };
    let start = 0;
    let end = 1;
    let direction = Direction.None;

    while (end < str.length) {
        const startChar = str.charCodeAt(start);
        const endChar = str.charCodeAt(end);

        // Forward consecutive character.
        const forward = endChar === startChar + (end - start);
        // Backward consecutive character.
        const backward = endChar === startChar - (end - start);

        if (!isAlphaNumeric(startChar) || !isAlphaNumeric(endChar)) {
            // Reset on not alphanumeric characters.
            start = end;
            end += 1;
            direction = Direction.None;
        } else if (direction === Direction.None && (forward || backward)) {
            end += 1;
            direction = forward ? Direction.Forward : Direction.Backward;
        } else if (direction === Direction.Forward && forward) {
            // Continue forward consecutive characters.
            end += 1;
        } else if (direction === Direction.Backward && backward) {
            // Continue backward consecutive characters.
            end += 1;
        } else {
            // Reset.
            start = end;
            end += 1;
            direction = Direction.None;
        }

        if (end - start > maxConsecutive) {
            // Invalid string if more than the maximum consecutive characters are reached.
            return false;
        }
    }
    return true;
}
